import React from 'react'
import { Navigate } from 'react-router-dom'

import routePath from 'router/routePath'
import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'

type CommonAreaReservationsGateProps = {
  redirectTo?: string
  children: React.ReactElement
}

/**
 * Shows children only when common area reservations module is enabled in module config.
 */
export const CommonAreaReservationsGate: React.FC<
  CommonAreaReservationsGateProps
> = ({ children, redirectTo = routePath.notFound404 }) => {
  const { commonAreaReservations } = useModuleConfig()

  return commonAreaReservations.enabled ? (
    children
  ) : (
    <Navigate to={redirectTo} replace />
  )
}
